<div class="padding-xl main-body" [ngClass]="{ 'desktop': view.Desktop }">
    <span [hidden]="Page !== 'LOGIN'">
        <upp-login-page (Recovery)="OpenRecovery()" (Registry)="OpenRegistry()"></upp-login-page>
    </span>
    <span [hidden]="Page !=='REGISTRY'">
        <upp-registry-page (Accept)="OpenLogin($event)" (Cancel)="OpenLogin()"></upp-registry-page>
    </span>
    <span [hidden]="Page !=='RECOVERY'">
        <upp-recovery-page (Accept)="OpenLogin()" (Cancel)="OpenLogin()"></upp-recovery-page>
    </span>
    <div style="clear:both; height:20px;"></div>                    
</div>